import { Button, Divider, Paper, Stack, Typography } from '@mui/material';
import { IEntitlement } from 'API/compassRights';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { EntitlementHeader } from './EntitlementHeader';
import { EntitlementInformation } from './EntitlementInformation';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { DynamicArrow } from 'Components/DynamicArrow';

interface IEntitlementItem {
  entitlement: IEntitlement;
}

export const Entitlement = ({ entitlement }: IEntitlementItem) => {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const location = useLocation();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.CompassRights
  ).entitlements;

  const newPathname = location.pathname.replace(/\/$/, ''); // Removes trailing slash if present

  return (
    <Paper
      sx={{
        borderRadius: '16px',
        boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
        background: '#FFFFFF',
        width: '100%',
        padding: isDesktop ? '32px 40px' : '20px 16px 24px 16px',
        display: 'flex',
        flexFlow: isDesktop ? 'row' : 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '15px',
        cursor: 'pointer',
      }}
      tabIndex={0}
      onClick={() =>
        navigate(`${newPathname}/${entitlement.entitlementTypeId}`)
      }
      onKeyDown={onEnterOrEscapeKeyDown}
    >
      <Stack gap={'16px'}>
        <EntitlementHeader
          automatic={entitlement?.automatic}
          oneTime={entitlement?.oneTime}
          title={entitlement?.name}
          lastDateUse={entitlement?.lastDateTimeUsed}
          eligibleFrequency={entitlement?.eligibleFrequency}
          filteredCategories={{
            category: entitlement?.category,
            subCategory: entitlement?.subCategory,
          }}
        />
        <EntitlementInformation
          information={entitlement?.shortExplanation}
          contact={entitlement?.contact}
        />
      </Stack>
      {!isDesktop && (
        <Divider
          aria-hidden='true'
          orientation={'horizontal'}
          sx={{ borderColor: 'primary.shade_100', width: '100%' }}
        />
      )}
      <Button
        variant='primary'
        sx={{
          minWidth: isDesktop ? '166px' : '208px',
          minHeight: '46px',
          gap: '4px',
        }}
        onClick={() =>
          navigate(`${newPathname}/${entitlement.entitlementTypeId}`)
        }
        onKeyDown={onEnterOrEscapeKeyDown}
        aria-label={`${dictionary.extraInfoAria} ${entitlement?.name}`}
      >
        <Typography variant={'body4'} color={'#fff'}>
          {dictionary.extraInfo}
        </Typography>
        <DynamicArrow color={'#fff'} rotate={90} size={24} />
      </Button>
    </Paper>
  );
};
